module.exports = __webpack_public_path__ + "img/5.78557e8a.png";